export type OnboardingStep = 'connect' | 'template' | 'customize' | 'run' | 'complete';

export interface OnboardingState {
  currentStep: OnboardingStep;
  connectedIntegrationId?: string;
  selectedTemplateId?: string;
  createdWorkflowId?: string;
  completedAt?: string;
  dismissed?: boolean;
}

const STORAGE_KEY = 'foxgrid_onboarding';

export function getOnboardingState(): OnboardingState {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return JSON.parse(stored);
  } catch {
    /* ignore parse errors */
  }
  return { currentStep: 'connect' };
}

export function setOnboardingState(state: OnboardingState): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function isOnboardingComplete(): boolean {
  const state = getOnboardingState();
  return state.currentStep === 'complete' || state.dismissed === true;
}

export function dismissOnboarding(): void {
  setOnboardingState({ ...getOnboardingState(), dismissed: true });
}

export function resetOnboarding(): void {
  localStorage.removeItem(STORAGE_KEY);
}
